import FiltersModule from './filters/flight-filters-module';
import FlightSeatmapModule from './flight-seatmap/flight-seatmap-module';
import PassengersSeatsModule from './passengers-seats/passengers-seats-module';
import PassengerSeatModule from './passenger-seat/passenger-seat-module';

import FlightRecommendationModule from './flight-recommendation/flight-recommendation-module';
import FlightsRoutes from './flights-routes';
import FlightsInterceptor from './services/flights.interceptor';
import FlightResultsController from './controllers/FlightResultsCtrl';
import FlightsCarouselController from './controllers/flightsCarouselCtrl';
import FlightsMultitripController from './controllers/flightsMultitripCtrl';
import FlightsOnewayController from './controllers/flightsOnewayCtrl';
import FlightsRoundtripController from './controllers/flightsRoundtripCtrl';
import FlightsTypeaheadController from './controllers/flightsTypeaheadCtrl';

import UkrailResultsController from './controllers/ukrailResultsCtrl';

import FlightsService from './services/flights-service';
import FlightResultsSortTypes from './services/flight-results-sort-types';

const MODULE_NAME = 'App.Flights';
const module = angular
    .module(MODULE_NAME, [
        'app',
        FlightRecommendationModule,
        FiltersModule,
        FlightSeatmapModule,
        PassengersSeatsModule,
        PassengerSeatModule,
    ])
    .controller('FlightResultsController', FlightResultsController)
    .controller('FlightsCarouselController', FlightsCarouselController)
    .controller('FlightsMultitripController', FlightsMultitripController)
    .controller('FlightsOnewayController', FlightsOnewayController)
    .controller('FlightsRoundtripController', FlightsRoundtripController)
    .controller('FlightsTypeaheadController', FlightsTypeaheadController)
    .controller('UkrailResultsController', UkrailResultsController)
    .service('flightsService', FlightsService)
    .service('flightResultsSortTypes', FlightResultsSortTypes)
    .config(FlightsInterceptor)
    .config(FlightsRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flights-module.js